import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EXPERIMENT_SETTINGS_EXCLUDE_GENES_UPDATED } from 'redux/actionTypes/experimentSettings';
import endUserMessages from 'utils/endUserMessages';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import UploadStatus from 'utils/upload/UploadStatus';
var updateExcludeGenesFileUpload = function updateExcludeGenesFileUpload(experimentId, uploadStatus, percentProgress) {
  var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var url, body;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(uploadStatus !== UploadStatus.UPLOADING)) {
              _context.next = 11;
              break;
            }
            url = "/v2/experiments/".concat(experimentId, "/excludeGenes");
            body = {
              uploadStatus: uploadStatus
            };
            _context.prev = 3;
            _context.next = 6;
            return fetchAPI(url, {
              method: 'PATCH',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(body)
            });
          case 6:
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](3);
            handleError(_context.t0, endUserMessages.ERROR_UPDATE_SERVER_ON_UPLOAD_STATE);
          case 11:
            dispatch({
              type: EXPERIMENT_SETTINGS_EXCLUDE_GENES_UPDATED,
              payload: {
                experimentId: experimentId,
                excludeGenes: _objectSpread({
                  uploadStatus: uploadStatus,
                  percentProgress: percentProgress
                }, extra)
              }
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default updateExcludeGenesFileUpload;